import http from "../../../request";

export default {
  // all: async (context) => {
  //   let response = await http.get("media", localStorage.getItem("lang"));
  //   context.commit("setArchive", response);
  // },
  filterArchive: async (context, payload) => {
    console.log(payload);
    if (!context.state.allArchivesLoaded) {
      context.commit("noResult", false);

      let response = await http.get(
        `media/filter/${payload.type}/${payload.year}`,
        `${localStorage.getItem("lang")}&page=${context.state.page}`
      );
      context.commit("setArchive", response.data);
      if (response.data.length == 0) {
        context.commit("noResult", true);
      }
      context.commit("setMeta", response.meta);
      if (context.state.meta) {
        if (context.state.meta.last_page > context.state.page) {
          context.commit("increasePage");
        } else {
          context.commit("allArchivesLoaded", true);
        }
      }
    }
  },
  getWriting: async (context, payload) => {
    let response = await http.get(
      `media/${payload}`,
      `${localStorage.getItem("lang")}`
    );
    context.commit("setWriting", response.data);
  },
  resetArchive: (context) => {
    context.commit("reset");
  },
};
